<template>
<PageView title="专项整治通知详情">
  <template slot="action" class="action">
    <a-button  @click="onEdit" icon="edit">编辑</a-button>
    <a-popconfirm placement="bottom" title="是否确认删除?" @confirm="onDel">
      <a-button :loading="delLoading" type="danger" icon="delete">删除
      </a-button>
    </a-popconfirm>
  </template>
  <ExpertYearAssessViewTable :info="info"/>
</PageView>
</template>

<script>
import { PageView } from '@/layouts'
import ExpertYearAssessViewTable from '@/epp/expertmain/expertyearassess/common/ExpertYearAssessViewTable'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'ExpertYearAssessView',
  components: {
    PageView,
    ExpertYearAssessViewTable
  },
  data () {
    return {
      id: this.$route.query.id,
      caseTypeId: '',
      user: this.$ls.get('user'),
      xwfState: {},
      info: {
        extras: {}
      },
      form: {},
      delLoading: false,
      printType: 'FCCCSPD'
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onLoadXWFState (xwfState) {
      this.xwfState = xwfState
      this.caseTypeId = xwfState.caseTypeId
    },
    onWFBeforeNext () { // 流程点下一步
      // 进行业务逻辑判断，如判断必需的内容是否已填写
      // if (this.xwfState.hasEvtSignOut) {//判断会议记录是否有填写
      //   if(this.$refs.meetingRef.resultSize===0){
      //     if (!confirm("会议安排还未填写，是否确定执行下一步操作？")) {
      //       return false
      //     }
      //   }
      // }
      return true
    },
    async loadData () {
      const res = await this.$http.get(
        `/api/1/expertyearassess/get_ExpertYearAssessById.json?id=${this.id}`
      )
      this.info = res.result
    },
    onEdit () {
      this.$router.push({ path: `/expertYearAssess/edit?id=${this.id}` })
    },
    // 删除处理
    async onDel () {
      this.delLoading = true
      const res = await this.$http.post(`/api/1/expertyearassess/delete_ExpertYearAssess.json?id=${this.id}`)
      this.delLoading = false

      if (res.code !== 200) {
        this.$message.error('删除失败')
        return
      }
      this.$message.success('删除成功')
      // this.$router.push({ path: '/attendance/evection/index' })
      this.$router.go(-1)
    },
    onPrint () {
      const docType = this.printType
      var postUrl = 'api/1/evection/query_printing_overtime.json?caseId=' + this.xwfState.caseId + '&id=' + this.info.id + '&docType=' + docType + '&X-Auth-Token=' + this.$ls.get(ACCESS_TOKEN)
      if (window.isbigant) {
        postUrl = process.env.VUE_APP_WEB_SERVER + '/' + postUrl
        window.openBigAnt.OpenByIE(postUrl, '_blank')
      } else {
        postUrl = this.$_c + postUrl
        window.open(postUrl, '_blank')
      }
    }
  }
}
</script>

<style scoped>

</style>
